export default function Marquee({ items, dark = false, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden mask-fade-x ${className}`} data-testid="tech-marquee">
      <div className="flex w-max animate-marquee items-center gap-16 md:gap-24 py-2">
        {row.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className={`font-display text-xl md:text-2xl font-medium tracking-tight whitespace-nowrap transition-colors duration-300 ${
              dark ? "text-slate-600 hover:text-pink-400" : "text-muted-foreground/60 hover:text-accent"
            }`}
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
